/**
 * Custom hook for managing connection notifications
 */

import { useState, useEffect } from 'react';
import { useAuth } from '../../../core/contexts/AuthContext';
import { subscribeToConnectionNotifications } from '../../../services/firebase/notificationService';

/**
 * Hook to manage connection notifications
 * 
 * @returns {Object} Connection notifications data and count
 */
const useConnectionNotifications = () => {
  const { currentUser } = useAuth();
  const [connectionNotifications, setConnectionNotifications] = useState([]);
  const [unreadConnectionCount, setUnreadConnectionCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setConnectionNotifications([]);
      setUnreadConnectionCount(0);
      setLoading(false);
      return;
    }

    setLoading(true);

    // Subscribe to connection notifications
    const unsubscribe = subscribeToConnectionNotifications(currentUser.uid, (notifications) => {
      setConnectionNotifications(notifications);
      
      // Count unread connection notifications
      const unreadCount = notifications.filter(notification => !notification.isRead).length;
      setUnreadConnectionCount(unreadCount);
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  return {
    connectionNotifications,
    unreadConnectionCount,
    loading
  };
};

export default useConnectionNotifications;